import styled from "styled-components";
import { useTable } from "react-table";
import PropTypes from "prop-types";

const MainTableContainer = styled.div`
  background-color: #f5f6fa;
  display: flex;
  width: 100%;
`;

const TableWrapper = styled.div`
  max-height: 300px;
  overflow-y: auto;
  display: flex;
  width: 100%;
`;

const TableElement = styled.table`
  flex: 1;
`;

const TableHeader = styled.th`
  padding: 15px 25px;
  font-family: Inter;
  border-bottom: 2.5px solid #d2d2d2;
  position: sticky;
  top: 0;
  z-index: 1;
  font-size: 13px;
  background-color: #f5f6fa;
  font-weight: 700;
  color: #0f1419;
`;

const TableCell = styled.td`
  padding: 15px 25px;
  font-family: Arial;
  border-bottom: 2.5px solid #d2d2d2;
  font-size: 14px;
  background-color: white;
  color: #696969;
`;

function Table({ columns, data }) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  return (
    <MainTableContainer>
      <TableWrapper>
        <TableElement {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, i) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={i}>
                {headerGroup.headers.map((column, j) => (
                  <TableHeader {...column.getHeaderProps()} key={j}>
                    {column.render("Header")}
                  </TableHeader>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.slice(0, 30).map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, j) => (
                    <TableCell {...cell.getCellProps()} key={j}>
                      {cell.render("Cell")}
                    </TableCell>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </TableElement>
      </TableWrapper>
    </MainTableContainer>
  );
}

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Table;
